/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageMine.vue?vue&type=template&id=15b1d55e&scoped=true"
import script from "./pageMine.vue?vue&type=script&lang=js"
export * from "./pageMine.vue?vue&type=script&lang=js"
import style0 from "./pageMine.vue?vue&type=style&index=0&id=15b1d55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1d55e",
  null
  
)

export default component.exports